import React, { useState, useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { formatToDateTime } from "./main/formatToDateTime";

export default function WarehouseData({ type, start, end }) {
  const [Data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    GetData();
  }, [type, start, end]);

  const GetData = async (page = 1) => {
    setLoading(true);
    let url = `https://ctas.live/backend/api/${type}/transaction?page=${page}`;
    if (start) {
      url += `&start=${start}`;
    }
    if (end) {
      url += `&end=${end}`;
    }
    try {
      const response = await axios.get(url);
      if (response.data && response.data) {
        setData(response.data.data);
      } else {
        Swal.fire({
          icon: "Info",
          text: `Something Want Wrong..!`,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: `Error in Data Fetch: ${error.message}`,
        timer: 3000,
        showConfirmButton: false,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      )}

      <div className="row">
        <div className="card">
          <div className="card-body px-1">
            <div className="table-responsive text-nowrap">
              {type == "de_stuffing" ? (
                <table className="table table-hover table-striped table-sm">
                  <thead>
                    <tr className="table-primary">
                      <td>SN</td>
                      <td>Type</td>
                      <td>Container No</td>
                      <td>Size</td>
                      <td>Package Weight</td>
                      <td>No Of Package</td>
                      <td>Grid Area</td>
                      <td>Start DateTime</td>
                      <td>End DateTime</td>
                      <td>Handling Type</td>
                    </tr>
                  </thead>
                  <tbody>
                    {Data?.data?.map((item, index) => (
                      <tr key={index}>
                        <td>{item.rn}</td>
                        <td>{item.type}</td>
                        <td>{item.container_number}</td>
                        <td>{item.container_size}</td>
                        <td>
                          {item.de_stuffing_bill_details
                            ?.reduce(
                              (total, detail) =>
                                total +
                                (parseFloat(detail.package_weight) || 0),
                              0
                            )
                            .toFixed(2)}
                        </td>
                        <td>
                          {item.de_stuffing_bill_details?.reduce(
                            (total, detail) =>
                              total +
                              (parseInt(detail.no_of_packages_declared) || 0),
                            0
                          )}
                        </td>
                        <td>
                          {item?.de_stuffing_bill_details?.map((details, i) =>
                            details?.grid_area?.map((grid, k) => (
                              <small key={`${i}-${k}`} className="d-block">
                                {grid?.grid_locations}: {grid?.area}
                              </small>
                            ))
                          )}
                        </td>
                        <td>{formatToDateTime(item?.start_time)}</td>
                        <td>{formatToDateTime(item?.end_time)}</td>
                        <td>{item?.handling_type}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : type == "delivery" ? (
                <table className="table table-hover table-striped table-sm">
                  <thead>
                    <tr className="table-primary">
                      <td>SN</td>
                      <td>Container No</td>
                      <td>Size</td>
                      <td>GPM Number</td>
                      <td>Package Weight</td>
                      <td>No Of Package</td>
                      <td>Grid Area</td>
                      <td>Start DateTime</td>
                      <td>End DateTime</td>
                      <td>Handling Type</td>
                    </tr>
                  </thead>
                  <tbody>
                    {/* {data && data.data.length > 0 ? ( */}
                    {Data?.data?.map((item, index) => (
                      <tr key={index}>
                        <td>{item.rn}</td>
                        <td>{item.container_number}</td>
                        <td>{item.container_size}</td>
                        <td>{item?.gpm_number}</td>
                        <td>
                          {item.delivery_trucks
                            ?.reduce(
                              (total, detail) =>
                                total + (parseFloat(detail.pkgs_weight) || 0),
                              0
                            )
                            .toFixed(2)}
                        </td>
                        <td>
                          {item.delivery_trucks?.reduce(
                            (total, detail) =>
                              total + (parseInt(detail.no_of_pkgs) || 0),
                            0
                          )}
                        </td>
                        <td>
                          {item?.delivery_trucks?.map((details, i) =>
                            details?.grid_area?.map((grid, k) => {
                              if (grid?.grid_locations === "direct") {
                                if (i == 0) {
                                  return "Direct Delivery";
                                }
                              } else {
                                return (
                                  <small key={`${i}-${k}`} className="d-block">
                                    {grid?.grid_locations}: {grid?.area}
                                  </small>
                                );
                              }
                            })
                          )}
                        </td>
                        <td>
                          {item?.start_time &&
                            formatToDateTime(item?.start_time)}
                        </td>
                        <td>
                          {item?.end_time && formatToDateTime(item?.end_time)}
                        </td>
                        <td>{item?.handling_type}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : type == "carting" ? (
                <table className="table table-hover table-striped table-sm">
                  <thead>
                    <tr className="table-primary">
                      <td>SN</td>
                      <td>Type</td>
                      <td>CRN No</td>
                      <td>Port</td>
                      <td>Package Weight</td>
                      <td>No Of Package</td>
                      <td>Grid Area</td>
                      <td>Start DateTime</td>
                      <td>End DateTime</td>
                      <td>Handling Type</td>
                    </tr>
                  </thead>
                  <tbody>
                    {Data?.data?.map((item, index) => (
                      <tr key={index}>
                        <td>{item.rn} </td>
                        <td>{item.type}</td>
                        <td>{item.crn_number}</td>
                        <td>{item.gw_port_code}</td>
                        <td>
                          {item.carting_trucks
                            ?.reduce(
                              (total, detail) =>
                                total + (parseFloat(detail.pkgs_weight) || 0),
                              0
                            )
                            .toFixed(2)}
                        </td>
                        <td>
                          {item.carting_trucks?.reduce(
                            (total, detail) =>
                              total + (Number(detail.no_of_pkgs) || 0),
                            0
                          )}
                        </td>
                        <td>
                          {item?.carting_trucks?.map((details, i) =>
                            details?.grid_area?.map((grid, k) => (
                              <small key={`${i}-${k}`} className="d-block">
                                {grid?.grid_locations}: {grid?.area}
                              </small>
                            ))
                          )}
                        </td>
                        <td>{formatToDateTime(item.start_time)}</td>
                        <td>{formatToDateTime(item.end_time)}</td>
                        <td>{item?.handline_type}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <table className="table table-hover table-striped table-sm ">
                  <thead>
                    <tr className="table-primary">
                      <td>SN</td>
                      <td>Type</td>
                      <td>CRN No</td>
                      <td>Container No</td>
                      <td>Container Size</td>
                      <td>Port</td>
                      <td>Package Weight</td>
                      <td>No Of Package</td>
                      <td>Grid Area</td>
                      <td>Start DateTime</td>
                      <td>End DateTime</td>
                      <td>Handling Type</td>
                    </tr>
                  </thead>
                  <tbody>
                    {Data?.data?.map((item, index) => (
                      <tr key={index}>
                        <td>{item.rn}</td>
                        <td>{item.type}</td>
                        <td>{item.crn_number}</td>
                        <td>{item.container_number}</td>
                        <td>{item.container_size}</td>
                        <td>{item.gw_port}</td>
                        <td>
                          {item.stuffing_shipping_bill_details
                            ?.reduce(
                              (total, detail) =>
                                total +
                                (parseFloat(detail.package_weight) || 0),
                              0
                            )
                            .toFixed(2)}
                        </td>
                        <td>
                          {item.stuffing_shipping_bill_details?.reduce(
                            (total, detail) =>
                              total +
                              (Number(detail.no_of_packages_declared) || 0),
                            0
                          )}
                        </td>
                        <td>
                          {item?.stuffing_shipping_bill_details?.map(
                            (details, i) =>
                              details?.grid_area?.map((grid, k) => (
                                <small key={`${i}-${k}`} className="d-block">
                                  {grid?.grid_locations}: {grid?.area}
                                </small>
                              ))
                          )}
                        </td>
                        <td>{formatToDateTime(item.start_time)}</td>
                        <td>{formatToDateTime(item?.end_time)}</td>
                        <td>{item?.handling_type}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}

              {Data && Data?.data && (
                <div className="container mt-4">
                  <div className="row">
                    <div className="col-sm-12 col-md-6">
                      <div
                        className="dataTables_info"
                        id="DataTables_Table_0_info"
                        role="status"
                        aria-live="polite"
                      >
                        Showing {Data.from} to {Data.to} of {Data.total} entries
                      </div>
                    </div>
                    <div className="col-10 m-auto mt-2">
                      <div
                        className="dataTables_paginate paging_simple_numbers"
                        id="DataTables_Table_0_paginate"
                      >
                        <ul className="pagination ">
                          {Data &&
                            Data?.links &&
                            Data?.links?.map((link, q) => {
                              let showData =
                                Data.links.length == q + 1
                                  ? "Next"
                                  : q == 0
                                  ? "Previous"
                                  : link.label;
                              return (
                                <li
                                  key={q}
                                  className={`paginate_button page-item ${
                                    link.active === true ? "active" : ""
                                  }  ${
                                    showData == "Next" &&
                                    Data.current_page == Data.last_page
                                      ? "disabled"
                                      : showData == "Previous" &&
                                        Data.current_page == 1
                                      ? "disabled"
                                      : ""
                                  } `}
                                >
                                  <button
                                    onClick={() => {
                                      showData == "Previous"
                                        ? GetData(Data.current_page - 1)
                                        : showData == "Next"
                                        ? GetData(Data.current_page + 1)
                                        : GetData(link.label);
                                    }}
                                    aria-controls="DataTables_Table_0"
                                    role="link"
                                    aria-current="page"
                                    data-dt-idx={0}
                                    tabIndex={0}
                                    className="page-link"
                                  >
                                    {showData}
                                  </button>
                                </li>
                              );
                            })}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
